import React from "react";
import DiscountList from "./partials/DiscountList";
import AddDiscount from "./partials/AddDiscount";

export default function Discount() {
    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center my-4">
                <h2 className="brand-header">Discount Management</h2>
                <AddDiscount type="add" />
            </div>
            <DiscountList />
        </div>
    );
}
